<template>
  <router-view />
</template>

<script>
export default {
  name: "TestProcessSingle"
};
</script>
